import * as THREE from 'three';
import {addDragEffectOnClick} from 'components/customer/Preview3D/helpers/Three';

/**
 * Placeholder highlight.
 *
 * A placeholder highlights exactly like a cabinet: the same box outline and
 * coloured glow, in the same colours for selected (light blue), dragging
 * (dark blue), snapped (green) and overlapping (red). Rather than copying
 * that logic, each placeholder mesh gets the cabinet panel handler set from
 * `addDragEffectOnClick`, so the two can never drift apart. Only what differs
 * from a cabinet panel lives here.
 */

/**
 * Installs the cabinet highlight handlers on one mesh of a placeholder GLB.
 * Call once per mesh after the placeholder's materials are prepared.
 * @param {THREE.Object3D} mesh Placeholder mesh
 */
export const attachPlaceholderHighlight = (mesh: THREE.Object3D): void => {
    addDragEffectOnClick(mesh);

    // Wireframe view: a cabinet panel hides itself and leaves its edge
    // lines showing. A GLB mesh has no edge lines and would just vanish, so
    // placeholders stay solid in wireframe mode (as they always have).
    delete mesh.userData.onToggleWireframe;
};

/**
 * Whether `object` is the shared selection outline rather than part of the
 * placeholder model. Its geometry is shared by every product's outline, so
 * dispose code must leave it alone.
 * @param {THREE.Object3D} object Child of a placeholder group
 * @return {boolean} True for the selection outline
 */
export const isSelectionOutline = (object: THREE.Object3D): boolean =>
    Boolean(object.userData?.isSelectionOutline);
